import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from '@/assets/resources/en';
import ptbr from '@/assets/resources/pt-br';

Vue.use(VueI18n);

const config = new VueI18n({
  locale: 'en',
  fallbackLocale: 'pt-br',
  messages: {
    en,
    'pt-br': ptbr,
  },
});

export default config;
